<pp-side-panel-menu-button
  [ppText]="'dashboard' | ppTranslate"
  [ppDataTarget]="'Dashboard button'"
  ppDataTest="dashboardMenuItem"
  [ppIconSrc]="EIconPath.SIDE_PANEL_DASHBOARD"
  [ppActive]="ppRouterPath === '/dashboard'"
  [ppDisabled]="!ppActiveWorkspaceId || ppDisabled"
  (ppAction)="goToDashboard()"
></pp-side-panel-menu-button>
